import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ApiService} from "@ctms/api.service";
import {Patient} from "@shared/api/models/query/patient.model";
import {TimeAgoPipe} from "@shared/pipes/time-ago.pipe";

@Component({
    selector: 'cdss-patient-overview-v2-footer',
    imports: [CommonModule, TimeAgoPipe],
    providers: [ApiService],
    standalone: true,
    templateUrl: './patient-overview-v2-footer.component.html'
})
export class PatientOverviewV2FooterComponent {

    @Input() type: string = 'patient';
    @Input() patient: Patient = null;

    ngOnInit() {

    }
}
